import {Text} from '../../components/1elements'
import BulkImportFormatTemplate from '../../components/5templates/BulkImportFormatTemplate'

const Contacts = () => {
    const header = 'Add Multiple People for a Location from a CSV file'
    const description = (
        <>If you have new people to be added for a location, you can add the information in the file to import all of them at once.
            Before importing the data, review the
            <a href={'/format/contacts#formatGuidelines'}>format guidelines</a> below to avoid
            <a href={'/format/contacts#commonErrors'}>common errors</a> and to ensure a smooth import operation.</>
    )

    const beforeYouBegin = (<>
        <li><Text type={'bulkImportRuleBody'}>
            <b>Validate this is the right way to proceed</b>- Use this option if you have multiple imports. You can
            import up to NEW 1000 contacts per client location. <b>Note</b> that you can do a single import by using
            the inbuilt smart form under data management.
        </Text></li>
        <li><Text type={'bulkImportRuleBody'}>
            <b>Make sure you have all the information ready</b>- Creating a contact requires information related to the
            personnel working in different capacities like employees, contractors, or part-time staff and becomes the primary
            link for associating and displaying people information. Keep all the information ready for associating the people
            to a location. Refer to the <a href={'/format/contacts#columnReference'}>column reference</a> to know about all the mandatory fields.
        </Text></li></>)

    const requiredColumns = [
        {
            columnName: 'Contact Type',
            description: 'The category under which the person would be placed. You can see the categories as an accordion ' +
                'on the left side under the people tab in the application.',
            limit:  '',
            example: 'Client, Contractor'
        },
        {
            columnName: 'First Name',
            description: 'First and middle name of the contact personnel.',
            limit:  '',
            example: 'Mary Ann'
        },
        {
            columnName: 'Last Name',
            description: 'Last name of the contact personnel.',
            limit:  '',
            example: 'Louis'
        },
        {
            columnName: 'Job Title',
            description: 'Enter the title held by the person in the organization.',
            limit:  '',
            example: 'VP Sales, Supervisor'
        },
        {
            columnName: 'Email',
            description: 'Official email of the person. If unavailable, please enter the admin/support email address to ' +
                'connect to the personnel.',
            limit:  '',
            example: 'mary.louis@company.com'
        },
        {
            columnName: 'Organization (for contractor only)',
            description: 'If the contact type is a contractor, this additional information is required for associating the contractor with their parent organization.',
            limit:  '',
            example: 'Green Service Ltd.'
        },
    ]

    const optionalColumns = [
        {
            columnName: 'Phone Number',
            description: 'Phone number of the contact personnel',
            format: 'Enter 10 numbers only',
            limit:  '',
            example: '6046046040'
        },
        {
            columnName: 'Description',
            description: 'Additional information regarding the person',
            format: '',
            limit:  '',
            example: 'works Mondays and Fridays only'
        },
        {
            columnName: 'Training Record Type',
            description: 'If there are training records associated with the person, enter the details here.\n' +
                'Type of training records can be found under the people tab for any contact personnel.\n',
            format: '',
            limit:  '',
            example: 'Onboarding, Offboarding, WHMIS, gcp'
        },
        {
            columnName: 'Record Name',
            description: 'Name of the record that will be the display title under the type selected above. This could be the same or different than the training record type',
            format: '',
            limit:  '',
            example: 'Onboarding, Cloud Professional'
        },
        {
            columnName: 'Record Link',
            description: ['Uniform Resource Locator/ reference of file storage location for the training record.', <br/>,<b>Please note</b>, ' that the system does not store the source file but only the reference link pointing to the file location.'],
            format: '',
            limit:  '',
            example: 'https://docs.google.com/spreadsheets/d/1xQwIpr'
        },
        {
            columnName: 'Expiry Date',
            description: 'The date when the training record expires. If not applicable, please leave blank',
            format: 'YYYY-MM-DD',
            limit:  'Only future date allowed',
            example: ''
        },
        {
            columnName: 'Effective Date',
            description: 'The date when the training becomes effective',
            format: 'YYYY-MM-DD',
            limit:  'No past date allowed',
            example: ''
        },
    ]

    const columnReferencePath = '/format/contacts#columnReference'

    return (
        <BulkImportFormatTemplate header={header} description={description} beforeYouBegin={beforeYouBegin}
                                  requiredColumns={requiredColumns} optionalColumns={optionalColumns} columnReferencePath={columnReferencePath}/>
    )
}

export default Contacts